import React from 'react';
import _ from 'lodash';
import RateTable from './RateTable';
import { rateTableWidth } from '../../constants';

interface Props {
  rates: { term: string; apy: string; }[];
}

const TermApyTable = ({ rates }: Props) => {
  return (
    <RateTable>
      <thead>
        <tr>
          <th>Term</th>
          <th style={{ width: rateTableWidth }}>APY*</th>
        </tr>
      </thead>
      <tbody>
        {
          _.map(rates, (rate, i) => (
            <tr key={i}>
              <td>{rate.term}</td>
              <td>{rate.apy}</td>
            </tr>
          ))
        }
      </tbody>
    </RateTable>
  );
};

export default TermApyTable;
